module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/026-qatar-f2621271fadcfca4fe2bdd97f8bc4d61.svg";